export const checkinList = {
  group: {
    sectionTitle: "Check-ins associados",
    registrationForm: "Ficha de registo",
    registrationFormHint: "Um único documento com o titular e os seus acompanhantes",
    registrationFormEmpty: "Ainda não há nenhum check-in feito nesta reserva.",
    registrationFormError: "Não foi possível gerar a ficha. Tenta de novo.",
    emptyState: "Nenhum check-in associado.",
    name: "Nome",
    phone: "Telefone",
    document: "Documento",
    notAvailable: "Não disponível",
    syncSent: "Enviado à imigração",
    syncError: "Erro na imigração",
    syncPending: "Envio pendente",
    moreInfo: "Mais informações",
    email: "E-mail",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Tipo de documento",
    supportNumber: "Número de suporte",
    documentBack: "Verso",
    identityNoMatch: "Os rostos não coincidem",
    identityStored: "Sem comparação facial",
    identityError: "Não foi possível comparar",
    identityNoPhotos: "Neste país não se guardam as fotos: fica apenas o resultado.",
    identityVerification: "Verificação de identidade",
    tapToEnlarge: "Toque para ampliar",
    view: "Ver",
    download: "Baixar",
    selfie: "Selfie",
    minorData: "Dados do menor",
    relationship: "Parentesco:",
    noPhotos: "Nenhuma foto anexada.",
    minorDocument: "Documento do menor",
    authorization: "Autorização",
    minorAuthorization: "Autorização do menor",
    specification: "Especificação:",
    additionalInfo: "Informações adicionais",
    nationality: "Nacionalidade",
    birthDate: "Data de nascimento",
    ageYears: "({age} anos)",
    gender: "Sexo",
    female: "Feminino",
    male: "Masculino",
    countryResidence: "País de residência",
    cityResidence: "Cidade de residência",
    address: "Endereço",
    zipCode: "Código postal",
    sesBatchId: "ID do lote SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "País de nascimento",
    docIssuePlace: "Local de emissão do documento",
    signedDocument: "Documento assinado",
    edit: "Editar",
    remove: "Excluir",
    previewAlt: "Pré-visualização",
    previewFallbackTitle: "Imagem",
    docTypes: {
      passport: "Passaporte",
      passportOrdinary: "Passaporte comum",
      passportService: "Passaporte de serviço",
      passportDiplomatic: "Passaporte diplomático",
      idCard: "Documento de identidade",
      nie: "NIE",
      idCardElectronic: "Documento de identidade eletrônico",
      idDiplomatic: "Documento de identidade diplomático",
      citizenshipCard: "Cédula de cidadania",
      foreignerCard: "Carteira de identidade de estrangeiro",
      drivingLicense: "Carteira de motorista",
      nauticalLicense: "Habilitação náutica",
      specialResidencePermit: "Autorização de residência especial",
      foreignerDocument: "Documento de estrangeiro",
      foreignDocument: "Documento estrangeiro",
      diplomaticCard: "Cartão diplomático",
      refugeeTravelDocument: "Documento de viagem de refugiado",
      otherDocument: "Outro documento",
    },
  },
  individual: {
    title: "Dados do hóspede",
    phone: "Telefone",
    email: "E-mail",
    notAvailable: "Não disponível",
    lodging: "Estadia",
    docType: "Tipo de documento",
    docNumber: "Número do documento",
    supportNumber: "Número de suporte",
    identityVerification: "Verificação de identidade",
    document: "Documento",
    tapToEnlarge: "Toque para ampliar",
    view: "Ver",
    download: "Baixar",
    selfie: "Selfie",
    minorData: "Dados do menor",
    relationship: "Parentesco:",
    noPhotos: "Nenhuma foto anexada.",
    minorDocument: "Documento do menor",
    authorization: "Autorização",
    minorAuthorization: "Autorização do menor",
    specification: "Especificação:",
    additionalInfo: "Informações adicionais",
    nationality: "Nacionalidade",
    birthDate: "Data de nascimento",
    ageYears: "({age} anos)",
    gender: "Sexo",
    female: "Feminino",
    male: "Masculino",
    countryResidence: "País de residência",
    cityResidence: "Cidade de residência",
    address: "Endereço",
    zipCode: "Código postal",
    sesBatchId: "ID do lote SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "País de nascimento",
    docIssuePlace: "Local de emissão do documento",
    signedDocument: "Documento assinado",
    edit: "Editar",
    previewAlt: "Pré-visualização",
    previewFallbackTitle: "Imagem",
    docTypes: {
      passport: "Passaporte",
      passportOrdinary: "Passaporte comum",
      passportService: "Passaporte de serviço",
      passportDiplomatic: "Passaporte diplomático",
      idCard: "Documento de identidade",
      nie: "NIE",
      idCardElectronic: "Documento de identidade eletrônico",
      idDiplomatic: "Documento de identidade diplomático",
      citizenshipCard: "Cédula de cidadania",
      foreignerCard: "Carteira de identidade de estrangeiro",
      drivingLicense: "Carteira de motorista",
      nauticalLicense: "Habilitação náutica",
      specialResidencePermit: "Autorização de residência especial",
      foreignerDocument: "Documento de estrangeiro",
      foreignDocument: "Documento estrangeiro",
      diplomaticCard: "Cartão diplomático",
      refugeeTravelDocument: "Documento de viagem de refugiado",
      otherDocument: "Outro documento",
    },
  },
};
